require './live-view-setup'
require './machine-activity-setup'
require './plugins'
require './machine-activity-map-setup'
require './bases-live-view-setup'